<template>
    <div class="layout-right"ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="库存管理-产品单位"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="item-box item-search">
                <search-box placeholder="产品单位名称" :btns="isMain ? searchOtherBtn : {}" @click="addEvent" @search="searchEvent"></search-box>
            </div>

            <div class="item-content" ref="itemContent">
                <div class="table-box">
                    <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil"
                              header-cell-class-name="table-ceil"
                    >
                        <el-table-column prop="name" label="单位名称"></el-table-column>
                        <el-table-column prop="create_datetime" label="添加时间"></el-table-column>
                        <el-table-column label="操作" size="200" v-if="isMain">
                            <template slot-scope="data">
                                <el-button
                                        size="mini"
                                        @click="handleEdit(data.$index, data.row)"
                                >编辑</el-button>
                                <el-button
                                        size="mini"
                                        type="danger"
                                        @click="handleDelete(data.$index, data.row)"
                                >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="layout-right-bottom">
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import RightTop from "@/model/RightTop";
    export default {
        name: "GoodsUnit",
        components: {RightTop, SearchBox, Menu},
        data: () => ({
            searchValue: "",
            searchOtherBtn: [
                {
                    label: "添加单位"
                }
            ],
            page: {
                nowPage: 1,
                pageSize: 50,
                pageSizes: [50, 100, 200, 400],
                count: 0,
            },
            tableAttr:{
                width: "100%",
                height: "100%"
            },
            tableData: [],
        }),
        computed: {
            isMain(){
                return this.$store.state.chain_option.is_main;
            }
        },
        mounted: function(){
            this.$store.commit("setMenuId", "3-3");
            this.loadListData();
        },
        methods: {
            //添加按钮点击
            addEvent: function () {
                obj.messageBox.prompt("请输入产品单位名称", "添加单位", {
                    confirmButtonText: '确认添加',
                    cancelButtonText: '取消',
                    inputType: "text",
                    inputPlaceholder: "",
                    inputValidator: function (value) {
                        //验证 返回bool或错误提示(string)
                        if(value === "" || value === null)
                            return "请输入单位名称";
                        else
                            return true;
                    }
                }).then( (data) => {
                    obj.postData("goods_unit/add_data", {name: data.value}, function (res) {
                        if(res.errcode === 0){
                            this.loadListData();
                            obj.message.success("添加成功");
                        } else {
                            obj.message.error("添加失败");
                        }
                    }.bind(this));

                } ).catch( () => {
                    return false;
                });
            }

            //编辑
            ,handleEdit: function (index, data) {
                obj.messageBox.prompt("请输入产品单位名称", "修改单位", {
                    confirmButtonText: '确认修改',
                    cancelButtonText: '取消',
                    inputType: "text",
                    inputPlaceholder: "",
                    inputValue: data.name,
                    inputValidator: function (value) {
                        //验证 返回bool或错误提示(string)
                        if(value === "" || value === null)
                            return "请输入单位名称";
                        else
                            return true;
                    }
                }).then( (mData) => {
                    obj.postData("goods_unit/set_data", {id: data.id, name: mData.value}, function (res) {
                        if(res.errcode === 0){
                            this.loadListData();
                            obj.message.success("修改成功");
                        } else {
                            obj.message.error("修改失败");
                        }
                    }.bind(this));

                } ).catch( () => {
                    return false;
                });
            }

            //删除
            ,handleDelete: function (index, data) {
                obj.messageBox.confirm("你确定要删除单位[ "+ data.name +" ]吗？", "警告", {
                    confirmButtonText: '确认删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( () => {
                    obj.postData("goods_unit/del_data", {id: data.id}, function (res) {
                        if(res.errcode === 0){
                            this.loadListData();
                            obj.message.success("删除成功");
                        } else {
                            obj.message.error("删除失败");
                        }
                    }.bind(this));

                } ).catch( () => {
                    return false;
                });
            }

            //搜索事件
            ,searchEvent: function (data) {
                this.searchValue = data.keyword ? data.keyword : "";
                this.loadListData();
            }

            //每页显示数量变化
            ,pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }

            //加载列表数据
            ,loadListData: function () {
                let postData = {
                    page: this.page.nowPage,
                    limit: this.page.pageSize,
                    name: this.searchValue
                };
                obj.postData("goods_unit/get_list_data", postData, function (res) {
                    if(res.errcode === 0){
                        this.page.count = res.count;
                        this.tableData = res.data;
                    }else{
                        this.tableData = [];
                    }
                }.bind(this));
            }
        }
    }
</script>

<style scoped>
    .layout-right-body>.item-search{
        height: 72px;
    }
    .layout-right-body>.item-content>.table-box{
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border-bottom: none;
        background-color: #ffffff;
        overflow:hidden;
        padding: 5px 16px 0;
    }
    .page-box{
        padding: 10px 20px;
        background: #ffffff;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border-top: 1px solid #ebedf0;
    }
    .layout-right-bottom{
        padding-top: 0px;
    }
</style>
